import React, { useState } from 'react';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch('https://formspree.io/f/mvzbdoqv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          email
        })
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  return <footer className="bg-gray-900 text-white pt-16 pb-8 border-t border-gray-800" data-id="element-178">
      <div className="container mx-auto px-4" data-id="element-179">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-180">
          <div className="col-span-1 md:col-span-1" data-id="element-181">
            <div className="mb-6" data-id="element-182">
              <div className="flex items-center" data-id="element-183">
                <span className="text-xl font-bold text-slate-200 tracking-tight lowercase leading-none" data-id="element-184">
                  swedenmark
                </span>
                <div className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 mx-0.5 translate-y-[22%]" data-id="element-185"></div>
                <span className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-186">
                  ai
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-187">
              AI Automation & Growth Consulting for mid-market companies. We
              turn intelligence into competitive advantage.
            </p>
          </div>

          <div data-id="element-188">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-189">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-190">
              <li data-id="element-191">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-192">
                  About Us
                </a>
              </li>
              <li data-id="element-193">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-194">
                  Services
                </a>
              </li>
              <li data-id="element-195">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-196">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-197">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-198">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-199">
              <li data-id="element-200">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-201">
                  Process Automation
                </a>
              </li>
              <li data-id="element-202">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-203">
                  Sales Acceleration
                </a>
              </li>
              <li data-id="element-204">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-205">
                  Marketing Intelligence
                </a>
              </li>
              <li data-id="element-206">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-207">
                  Operational Analytics
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-208">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-209">
              Stay Ahead
            </h3>
            <p className="text-gray-400 mb-4 text-sm" data-id="element-210">
              Get our latest insights on AI strategy for mid-market growth.
            </p>
            {status === 'success' ? <div className="bg-green-900/40 border border-green-700 text-green-300 rounded-lg px-4 py-3 text-sm" data-id="element-211">
                ✓ You're on the list — thanks for subscribing!
              </div> : <form onSubmit={handleSubscribe} className="flex flex-col gap-2" data-id="element-212">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Work email" required className="px-4 py-2 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-700 text-sm" data-id="element-213" />
                <button type="submit" disabled={status === 'submitting'} className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${status === 'submitting' ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} text-white`} data-id="element-214">
                  {status === 'submitting' ? 'Subscribing...' : 'Subscribe'}
                </button>
                {status === 'error' && <p className="text-red-400 text-xs" data-id="element-215">
                    Something went wrong. Please try again.
                  </p>}
              </form>}
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-216">
          <p className="text-gray-500 text-sm" data-id="element-217">
            &copy; {new Date().getFullYear()} Swedenmark AI. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-218">
            <a href="#" className="hover:text-white transition-colors" data-id="element-219">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-220">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}